import { Component, OnInit } from '@angular/core';
import { DataService } from './services/data.service';
import { Subject } from 'rxjs/Subject';
import { BusinesLogicService } from './services/business-logic.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  logged: boolean = false;
  turn: object = {};
  showAlert: boolean = false;

  private destroy$ = new Subject();

  constructor(public _data: DataService,
              public _blogic: BusinesLogicService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout() {
    window.location.reload();
  }

  refresh() {
    window.location.reload();
  }

  isContainerVisible(): boolean {
      return this._data.turn == null;
  }
}
